import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccessControlService } from '../access-control/access-control.service';
import {requestConfig} from "../../shared/constants/request.config";

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {
  constructor(private _accessControl: AccessControlService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (
      request.url.includes(requestConfig.oauth.path) ||
      request.url.includes(requestConfig.forgotPassword.path) ||
      request.url.includes(requestConfig.recoverPassword.path) ||
      request.url.includes(requestConfig.refreshToken.path) ||
      request.url.includes('storage.cloudconvert.com') ||
      request.url.includes('storage.de.cloud.ovh.net')
    ) {
      return next.handle(request);
    }else{
      request = request.clone({
        headers: request.headers.append('authorization',`Bearer ${this._accessControl.getBearerToken()}`)
      })
      return next.handle(request);
    }
  }
}
